<template>
    <div class="position-relative">
        <div class="dropdown" v-if="isLoggedIn">
            <a href="#" id="accountMenuList" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-boundary="window">
                <i class="fa fa-user-o"></i>
            </a>
            <div class="account-menu dropdown-menu dropdown-menu-right small">
                <div class="list-group" aria-labelledby="accountMenuList" >
                    <a :href="$ceres.urls.myAccount" class="list-group-item small"> {{ $translate("Ceres::Template.loginMyAccount") }}</a>
                    <a href="#" class="list-group-item small" v-logout> {{ $translate("Ceres::Template.loginLogout") }}</a>
                </div>
            </div>
        </div>
        <div v-if="!isLoggedIn">
            <a :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
              <i class="fa fa-user-o"></i>
            </a>
        </div>
    </div>
</template>

<script>
    import ValidationService from "../../../services/ValidationService";
    import { mapGetters, mapActions } from "vuex";

    export default {
        props: {
            showRegistration: {
                type: Boolean,
                default: true
            },
            showLogin: {
                type: Boolean,
                default: true
            }
        },

        computed: {
            ...mapGetters([
                "username",
                "isLoggedIn"
            ])
        },

        data()
        {
            return {
                isLogin: App.templateType === "login",
                isRegister: App.templateType === "register"
            };
        },

        methods: {
            unmarkInputFields()
            {
                ValidationService.unmarkAllFields($("#login"));
                ValidationService.unmarkAllFields($("#registration"));
            },

            createLoginModal()
            {
                this.loadComponent("login-modal");
            },

            createRegisterModal()
            {
                this.loadComponent("register-modal");
            },

            ...mapActions([
                "loadComponent"
            ])
        }
    }
</script>
